export default "__VITE_ASSET__CsiBUkUP__"